export function hoursUntilEvent(eventDate, eventTime, now = new Date()) {
  if (!eventDate) return null;
  const [year, month, day] = eventDate.split("-").map(Number);
  if (![year, month, day].every(Number.isFinite)) return null;

  const match = String(eventTime || "").trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!match) return null;
  let hour = Number(match[1]) % 12;
  if (match[3].toUpperCase() === "PM") hour += 12;
  const minute = Number(match[2]);
  const eventAt = new Date(year, month - 1, day, hour, minute);
  if (Number.isNaN(eventAt.valueOf())) return null;
  return (eventAt.valueOf() - now.valueOf()) / 3600000;
}